// removed by extract-text-webpack-plugin
module.exports = {"formContent":"c-PaymentOptions__formContent","price":"c-PaymentOptions__price","buttonWrapper":"c-PaymentOptions__buttonWrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/PaymentOptions/PaymentOptions.scss
// module id = 915
// module chunks = 0